import React, {useContext} from 'react';

const SingleSelectContext = React.createContext();

export const useSingleSelectContext = () => useContext(SingleSelectContext);

export default SingleSelectContext;
